const byoxHandlers = {};

const parseItemCountFromSections = (sections) => {
  const html = sections?.['cart-icon-bubble'];
  if (!html) return null;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const countEl = doc.querySelector('.cart-count-bubble span[aria-hidden]');
  if (countEl) return parseInt(countEl.textContent, 10) || 0;
  return doc.querySelector('.cart-count-bubble') ? 100 : 0;
};

document.addEventListener("DOMContentLoaded", () => {
  const variantSelector = ".variant-item";
  const addPanelSelector = ".variant-item__add-panel";
  const stepperSelector = ".variant-item__stepper";
  const qtyValueSelector = ".variant-qty-value";
  const minusSelector = ".variant-qty-minus";
  const plusSelector = ".variant-qty-plus";
  const mainAddSelector = '[data-action="add-to-cart"]';
  const variantPlansEl = document.getElementById("custom-product-variant-plans");
  const buildBoxPricingEl = document.getElementById(
    "main-product-build-box-pricing"
  );
  const buildBoxRoot = document.querySelector(".build-your-box");
  const variantPlanMap = (() => {
    if (!variantPlansEl) return {};
    try {
      return JSON.parse(variantPlansEl.textContent);
    } catch {
      return {};
    }
  })();

  const buildBoxPricing = (() => {
    if (!buildBoxPricingEl) return { variants: {} };
    try {
      return JSON.parse(buildBoxPricingEl.textContent);
    } catch {
      return { variants: {} };
    }
  })();

  const purchaseOptionsEl = document.querySelector(".product__purchase-options");
  const subscribePlanEl = document.querySelector("#custom-product-selling-plan");

  /** @type {NodeListOf<HTMLElement>} */
  const variantRows = document.querySelectorAll(variantSelector);
  /** @type {HTMLButtonElement | null} */
  const mainAddBtn = document.querySelector(mainAddSelector);

  const isByoxRow = (row) => row.classList.contains("variant-item--byox");

  const proportionalByox = () => !!buildBoxRoot;

  const byoxRows = () =>
    [...variantRows].filter((r) => isByoxRow(r) && !r.dataset.disabled);

  const formatMoneyCents = (cents, formatStr) => {
    const v = (Number(cents) || 0) / 100;
    const amount = v.toFixed(2);
    if (formatStr && /\{\{/.test(formatStr)) {
      return formatStr
        .replace(/\{\{\s*amount\s*\}\}/gi, amount)
        .replace(/\{\{amount\}\}/gi, amount);
    }
    return `$${amount}`;
  };

  const getPurchaseTypeChecked = () =>
    document.querySelector(
      'input[name="custom-product-purchase-type"]:checked'
    );

  const getSelectedSellingPlanId = () => {
    const el = document.querySelector(
      'input[name="custom-product-purchase-type"]:checked'
    );
    if (!el || el.value === "onetime") return null;
    if (!subscribePlanEl) return null;
    const n = parseInt(
      subscribePlanEl instanceof HTMLInputElement
        ? subscribePlanEl.value
        : "",
      10
    );
    return Number.isFinite(n) ? n : null;
  };

  const planAllowedForVariant = (allowed, planId) => {
    if (planId == null || planId === "") return false;
    const key = String(planId);
    if (!Array.isArray(allowed)) return false;
    return allowed.some((x) => String(x) === key);
  };

  const parseMaxQty = (row) => {
    const n = parseInt(row.dataset.maxQty || "9999", 10);
    return Number.isFinite(n) && n >= 0 ? n : 9999;
  };

  const getQty = (row) => {
    const span = row.querySelector(qtyValueSelector);
    if (!span) return 0;
    if (isByoxRow(row)) {
      return parseInt(span.textContent || "0", 10) || 0;
    }
    const stepper = row.querySelector(stepperSelector);
    if (stepper && stepper.hidden) return 0;
    return parseInt(span.textContent || "0", 10) || 0;
  };

  const updateMainButton = () => {
    if (!mainAddBtn) return;
    let total = 0;
    variantRows.forEach((row) => {
      total += getQty(row);
    });
    mainAddBtn.disabled = total === 0 && !proportionalByox();
  };

  const updateBuildBoxUI = (root) => {
    if (!(root instanceof HTMLElement)) return;
    const moneyFormat = root.dataset.moneyFormat || "${{amount}}";
    const rows = root.querySelectorAll(".variant-item--byox");
    let totalQty = 0;
    rows.forEach((row) => {
      if (row.dataset.disabled) return;
      totalQty += getQty(row);
    });

    const servings = parseInt(root.dataset.servingsPerPack || "30", 10) || 30;
    const packsEl = root.querySelector(".build-your-box__packs-line");
    const saveEl = root.querySelector(".build-your-box__save-line");
    const bannerEl = root.querySelector(".build-your-box__banner");
    const footerEl = root.querySelector(".build-your-box__footer");

    if (packsEl) {
      if (totalQty <= 0) {
        packsEl.textContent = "";
        packsEl.hidden = true;
      } else {
        packsEl.hidden = false;
        const totalServings = servings * totalQty;
        packsEl.textContent =
          totalQty === 1
            ? `1 pack – ${totalServings} servings`
            : `${totalQty} packs – ${totalServings} servings`;
      }
    }

    if (footerEl) {
      footerEl.classList.toggle(
        "build-your-box__footer--save-only",
        totalQty <= 0
      );
    }

    const planId = getSelectedSellingPlanId();
    const typeEl = getPurchaseTypeChecked();
    const isSubscribe = typeEl?.value === "subscribe";

    let saveCents = 0;
    if (isSubscribe && planId != null) {
      rows.forEach((row) => {
        if (row.dataset.disabled) return;
        const vid = row.dataset.variantId;
        const qty = getQty(row);
        if (!vid || qty <= 0) return;
        const v = buildBoxPricing.variants?.[vid];
        const pl = v?.plans?.[String(planId)];
        if (pl && Number(pl.compare) > Number(pl.price)) {
          saveCents += (Number(pl.compare) - Number(pl.price)) * qty;
        }
      });
    }

    if (saveEl) {
      saveEl.textContent = `You save ${formatMoneyCents(saveCents, moneyFormat)}`;
    }

    if (bannerEl) {
      const saveFormatted = formatMoneyCents(saveCents, moneyFormat);
      if (totalQty <= 0) {
        bannerEl.innerHTML =
          "Add a <strong>first pack</strong> to save even more on your subscription";
      } else if (totalQty === 1) {
        bannerEl.innerHTML =
          "Add a <strong>2nd pack</strong> to save even more on your subscription";
      } else if (totalQty === 2) {
        bannerEl.innerHTML =
          "Add a <strong>3rd pack</strong> for best value — maximum savings per pack";
      } else if (totalQty >= 3) {
        if (isSubscribe) {
          bannerEl.innerHTML = `Great choice! You're saving <strong>${saveFormatted}</strong> with your subscription`;
        } else {
          bannerEl.innerHTML =
            "Great choice! Switch to <strong>Subscribe & Save</strong> to see your subscription savings.";
        }
      }
    }
  };

  const refreshBuildBox = () => {
    document.querySelectorAll(".build-your-box").forEach(updateBuildBoxUI);
    updateByoxMinusButtons();
    updateCardPrices();
    updateMainProductCta();
  };

  const calcByoxTotals = (planId, isSubscribe) => {
    if (!buildBoxRoot) return null;
    const moneyFormat = buildBoxRoot.dataset.moneyFormat || "";
    const rows = [...variantRows].filter((r) => isByoxRow(r) && !r.dataset.disabled);
    let priceCents = 0;
    let compareCents = 0;
    let hasAny = false;
    rows.forEach((row) => {
      const vid = row.dataset.variantId;
      const qty = getQty(row);
      if (!vid || qty <= 0) return;
      const v = buildBoxPricing.variants?.[vid];
      if (!v) return;
      hasAny = true;
      if (isSubscribe && planId != null) {
        const pl = v.plans?.[String(planId)];
        priceCents += (pl ? Number(pl.price) : Number(v.onetime)) * qty;
        compareCents += (pl ? Number(pl.compare) : Number(v.onetime)) * qty;
      } else {
        priceCents += Number(v.onetime) * qty;
        compareCents += Number(v.onetime) * qty;
      }
    });
    if (!hasAny) return null;
    return { priceCents, compareCents, moneyFormat };
  };

  const updateMainProductCta = () => {
    const btn = document.querySelector(".main-product-subscribe-cta");
    if (!btn || !(btn instanceof HTMLButtonElement)) return;
    const root = document.querySelector(".main-product-buy");
    const prefix = (root && root.dataset.ctaOnetimePrefix) || "Add to Cart";
    const onetimeMoney = (root && root.dataset.onetimePriceMoney) || "";
    const typeEl = document.querySelector(
      'input[name="custom-product-purchase-type"]:checked'
    );
    const isSubscribe = typeEl?.value === "subscribe";
    const planId = getSelectedSellingPlanId();

    const textEl = btn.querySelector("span") || btn;
    if (isSubscribe && subscribePlanEl instanceof HTMLInputElement) {
      const pct = parseInt(subscribePlanEl.dataset.savePct || "0", 10) || 0;
      const totals = calcByoxTotals(planId, true);
      const price = totals !== null
        ? formatMoneyCents(totals.priceCents, totals.moneyFormat)
        : subscribePlanEl.dataset.priceMoney || "";
      textEl.textContent = pct > 0
        ? `Subscribe & save ${pct}% – ${price}`
        : `Subscribe & save – ${price}`;
    } else {
      const totals = calcByoxTotals(null, false);
      const price = totals !== null
        ? formatMoneyCents(totals.priceCents, totals.moneyFormat)
        : onetimeMoney;
      textEl.textContent = `${prefix} – ${price}`;
    }
  };

  const updateByoxMinusButtons = () => {
    if (!proportionalByox()) return;
    const rows = byoxRows();
    const total = rows.reduce((s, r) => s + getQty(r), 0);
    rows.forEach((row) => {
      const minus = row.querySelector(minusSelector);
      if (minus) minus.disabled = total <= 1 || getQty(row) <= 0;
    });
  };

  const updateCardPrices = () => {
    const planId = getSelectedSellingPlanId();
    const subTotals = calcByoxTotals(planId, true);
    const onetimeTotals = calcByoxTotals(null, false);

    const priceEl = document.querySelector(".product__purchase-subscribe-current");
    const compareEl = document.querySelector(".product__purchase-subscribe-compare");
    const onetimeEl = document.querySelector(".product__purchase-onetime-price");

    if (subTotals !== null) {
      const fmt = subTotals.moneyFormat;
      if (priceEl) priceEl.textContent = formatMoneyCents(subTotals.priceCents, fmt);
      if (compareEl) {
        if (subTotals.compareCents > subTotals.priceCents) {
          compareEl.textContent = formatMoneyCents(subTotals.compareCents, fmt);
          compareEl.classList.remove("product__purchase-subscribe-compare--empty");
        } else {
          compareEl.textContent = "";
          compareEl.classList.add("product__purchase-subscribe-compare--empty");
        }
      }
    }

    if (onetimeTotals !== null && onetimeEl) {
      onetimeEl.textContent = formatMoneyCents(onetimeTotals.priceCents, onetimeTotals.moneyFormat);
    }
  };

  const setQty = (row, qty) => {
    if (isByoxRow(row)) {
      const span = row.querySelector(qtyValueSelector);
      const stepper = row.querySelector(stepperSelector);
      if (!span || !stepper) return;
      const max = parseMaxQty(row);
      const next = Math.max(0, Math.min(max, qty));
      span.textContent = String(next);
      const plus = row.querySelector(plusSelector);
      const minus = row.querySelector(minusSelector);
      if (plus) plus.disabled = next >= max;
      if (minus) minus.disabled = next <= 0;
      updateMainButton();
      refreshBuildBox();
      return;
    }
    const span = row.querySelector(qtyValueSelector);
    const stepper = row.querySelector(stepperSelector);
    const addPanel = row.querySelector(addPanelSelector);
    if (!span || !stepper || !addPanel) return;
    const max = parseMaxQty(row);
    const next = Math.max(0, Math.min(max, qty));
    if (next === 0) {
      span.textContent = "1";
      stepper.hidden = true;
      addPanel.hidden = false;
      row.classList.remove("variant-item--has-qty");
    } else {
      span.textContent = String(next);
      stepper.hidden = false;
      addPanel.hidden = true;
      row.classList.add("variant-item--has-qty");
    }
    const plus = row.querySelector(plusSelector);
    const minus = row.querySelector(minusSelector);
    if (plus) plus.disabled = next >= max;
    if (minus) minus.disabled = next <= 0;
    updateMainButton();
  };

  const handleByoxPlus = (clickedRow) => {
    setQty(clickedRow, getQty(clickedRow) + 1);
  };

  const handleByoxMinus = (clickedRow) => {
    const rows = byoxRows();
    const t = rows.reduce((s, r) => s + getQty(r), 0);
    if (t <= 1) return;
    setQty(clickedRow, getQty(clickedRow) - 1);
  };

  const activateStepper = (row) => {
    if (row.dataset.disabled) return;
    setQty(row, 1);
    const id = row.dataset.variantId;
    if (id) {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", id);
      window.history.replaceState({}, "", url);
    }
  };

  const getLineItems = () => {
    const sellingPlanId = getSelectedSellingPlanId();
    if (sellingPlanId) {
      for (const row of variantRows) {
        const id = row.dataset.variantId;
        const qty = getQty(row);
        if (!id || qty <= 0) continue;
        const allowed = variantPlanMap[String(id)] || [];
        if (!planAllowedForVariant(allowed, sellingPlanId)) {
          return { items: [], planMismatch: true };
        }
      }
    }
    /** @type {{ id: number; quantity: number; selling_plan?: number }[]} */
    const items = [];
    variantRows.forEach((row) => {
      const id = row.dataset.variantId;
      const qty = getQty(row);
      if (!id || qty <= 0) return;
      const vid = parseInt(id, 10);
      if (!Number.isFinite(vid)) return;
      const line = { id: vid, quantity: qty };
      if (sellingPlanId) {
        line.selling_plan = sellingPlanId;
      }
      items.push(line);
    });
    if (items.length === 0 && proportionalByox()) {
      const firstRow = [...variantRows].find((r) => isByoxRow(r) && !r.dataset.disabled);
      if (firstRow) {
        const vid = parseInt(firstRow.dataset.variantId || "", 10);
        if (Number.isFinite(vid)) {
          const line = { id: vid, quantity: 1 };
          if (sellingPlanId) line.selling_plan = sellingPlanId;
          items.push(line);
        }
      }
    }
    if (items.length === 0) {
      const hid = document.querySelector(
        '.main-product-buy [data-umi-line-cart]:not([data-umi-onetime]) form input[name="id"]'
      );
      const n = parseInt(
        hid instanceof HTMLInputElement ? hid.value : "",
        10
      );
      if (Number.isFinite(n) && n > 0) {
        const line = { id: n, quantity: 1 };
        if (sellingPlanId) line.selling_plan = sellingPlanId;
        items.push(line);
      }
    }
    return { items, planMismatch: false };
  };

  const resetSelectionState = () => {
    variantRows.forEach((row) => {
      if (row.dataset.disabled) return;
      if (isByoxRow(row)) {
        const defaultQty = parseInt(row.dataset.defaultQty || "0", 10) || 0;
        setQty(row, defaultQty);
        return;
      }
      if (!row.querySelector(addPanelSelector)) return;
      setQty(row, 0);
    });
    const url = new URL(window.location.href);
    if (url.searchParams.has("variant")) {
      url.searchParams.delete("variant");
      window.history.replaceState({}, "", url);
    }
  };

  const syncSubscribePrices = () => {
    if (subscribePlanEl instanceof HTMLInputElement) {
      const pct = subscribePlanEl.dataset.savePct || "0";
      const saveLineEl = document.querySelector(".product__purchase-save-line");
      const tpl =
        purchaseOptionsEl?.dataset.saveTemplate ||
        "Save {pct}% on every delivery";
      if (saveLineEl) {
        const p = parseInt(pct, 10) || 0;
        if (p > 0 && tpl.trim()) {
          saveLineEl.textContent = tpl.replace(/\{pct\}/g, String(p));
          saveLineEl.classList.remove("product__purchase-save-line--hide");
        } else {
          saveLineEl.classList.add("product__purchase-save-line--hide");
        }
      }
    }
    refreshBuildBox();
  };

  variantRows.forEach((row) => {
    if (isByoxRow(row)) {
      if (row.dataset.disabled) return;
      const defaultQty = parseInt(row.dataset.defaultQty || "0", 10) || 0;
      setQty(row, defaultQty);
      return;
    }
    if (row.dataset.disabled) return;
    if (!row.querySelector(addPanelSelector)) return;
    setQty(row, 0);
  });

  if (subscribePlanEl) {
    syncSubscribePrices();
  }

  document.querySelectorAll("[data-purchase-card]").forEach((card) => {
    card.addEventListener("click", (e) => {
      if (e.target instanceof HTMLElement && e.target.closest("select")) {
        return;
      }
      const r = card.querySelector(
        'input[name="custom-product-purchase-type"]'
      );
      if (r instanceof HTMLInputElement) {
        r.checked = true;
      }
      refreshBuildBox();
      updateMainProductCta();
    });
  });

  document
    .querySelectorAll('input[name="custom-product-purchase-type"]')
    .forEach((inp) => {
      inp.addEventListener("change", () => {
        refreshBuildBox();
        updateMainProductCta();
      });
    });

  variantRows.forEach((row) => {
    row.addEventListener("click", (e) => {
      if (isByoxRow(row)) return;
      if (row.dataset.disabled) return;
      if (e.target instanceof HTMLElement && e.target.closest("button")) return;
      const addPanel = row.querySelector(addPanelSelector);
      if (addPanel && !addPanel.hidden) activateStepper(row);
    });
  });

  document.querySelectorAll(`${variantSelector} .add-btn`).forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const row = btn.closest(variantSelector);
      if (!row || row.dataset.disabled) return;
      activateStepper(row);
    });
  });

  document.querySelectorAll(minusSelector).forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const row = btn.closest(variantSelector);
      if (!row) return;
      if (isByoxRow(row) && proportionalByox()) {
        handleByoxMinus(row);
        return;
      }
      setQty(row, getQty(row) - 1);
    });
  });

  document.querySelectorAll(plusSelector).forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const row = btn.closest(variantSelector);
      if (!row || row.dataset.disabled) return;
      if (isByoxRow(row) && proportionalByox()) {
        handleByoxPlus(row);
        return;
      }
      setQty(row, getQty(row) + 1);
    });
  });

  byoxHandlers.getLineItems = getLineItems;

  byoxHandlers.getOnetimeLineItems = () => {
    const rows = [...variantRows].filter((r) => isByoxRow(r) && !r.dataset.disabled);
    const items = rows
      .filter((r) => getQty(r) > 0)
      .map((r) => ({ id: parseInt(r.dataset.variantId || "", 10), quantity: getQty(r) }))
      .filter(({ id }) => Number.isFinite(id) && id > 0);
    if (items.length === 0) {
      const first = rows[0];
      if (first) {
        const id = parseInt(first.dataset.variantId || "", 10);
        if (Number.isFinite(id) && id > 0) items.push({ id, quantity: 1 });
      }
    }
    if (items.length === 0) {
      const hid = document.querySelector(
        '.main-product-buy [data-umi-line-cart][data-umi-onetime] form input[name="id"]'
      );
      const n = parseInt(
        hid instanceof HTMLInputElement ? hid.value : "",
        10
      );
      if (Number.isFinite(n) && n > 0) items.push({ id: n, quantity: 1 });
    }
    return { items, planMismatch: false };
  };

  byoxHandlers.resetSelectionState = resetSelectionState;

  refreshBuildBox();
  updateMainProductCta();

  const cartSource = "custom-product-cart";

  document.querySelectorAll("[data-umi-line-cart]").forEach((root) => {
    if (!(root instanceof HTMLElement)) return;
    const form = root.querySelector("form");
    if (!form) return;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const submitButton = root.querySelector('[type="submit"]');
    const errorWrapper = root.querySelector(".cmp-umi__cart-error-wrap");
    const errorMessage = root.querySelector(".cmp-umi__cart-error");
    const isOnetime = root.hasAttribute("data-umi-onetime");
    if (cart && submitButton) {
      submitButton.setAttribute("aria-haspopup", "dialog");
    }

    const setLoading = (loading) => {
      const spinner = root.querySelector(".loading__spinner");
      if (loading) {
        submitButton?.setAttribute("aria-disabled", "true");
        submitButton?.classList.add("loading");
        spinner?.classList.remove("hidden");
      } else {
        submitButton?.removeAttribute("aria-disabled");
        submitButton?.classList.remove("loading");
        spinner?.classList.add("hidden");
        if (cart?.classList.contains("is-empty")) {
          cart.classList.remove("is-empty");
        }
      }
    };

    const showError = (message) => {
      if (!errorWrapper) return;
      if (message) {
        errorWrapper.removeAttribute("hidden");
        if (errorMessage) errorMessage.textContent = message;
      } else {
        errorWrapper.setAttribute("hidden", "");
      }
    };

    form.addEventListener("submit", (evt) => {
      evt.preventDefault();
      if (submitButton?.getAttribute("aria-disabled") === "true") return;
      showError(false);
      const result = isOnetime
        ? byoxHandlers.getOnetimeLineItems?.()
        : byoxHandlers.getLineItems?.();
      if (!result) return;
      if (result.planMismatch) {
        showError(
          "This subscription option is not available for one of the selected flavors."
        );
        return;
      }
      const { items } = result;
      if (!items.length) return;
      setLoading(true);
      const body = { items };
      if (cart) {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }
      const shopifyRoot =
        window.Shopify?.routes?.root?.replace(/\/?$/, "/") ?? "/";
      fetch(`${shopifyRoot}cart/add.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(body),
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: cartSource,
              productVariantId: String(items[0]?.id),
              errors: response.errors || response.description,
              message: response.message,
            });
            showError(response.description);
            return;
          }
          if (!cart) {
            window.location.href =
              window.routes?.cart_url ?? `${shopifyRoot}cart`;
            return;
          }
          const itemCount = parseItemCountFromSections(response.sections);
          const startMarker = CartPerformance.createStartingMarker(
            "add:wait-for-subscribers"
          );
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: cartSource,
            productVariantId: String(items[0]?.id),
            cartData: { ...response, item_count: itemCount ?? 0 },
          }).then(() => {
            CartPerformance.measureFromMarker(
              "add:wait-for-subscribers",
              startMarker
            );
          });
          CartPerformance.measure("add:paint-updated-sections", () => {
            cart.renderContents(response);
          });
          byoxHandlers.resetSelectionState?.();
        })
        .catch((e) => console.error(e))
        .finally(() => {
          setLoading(false);
        });
    });
  });
});
